module.exports = __webpack_public_path__ + "apple_macbook13_icon.svg?8b9aae157831e257b02fd5ea2e295bde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/apple_macbook13_icon.svg
// module id = 216
// module chunks = 0